import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useHasEnoughPriviledge} from '#imports';
import type {LightUser} from '@malt/nuxt-auth-module/models';
import {readonlyState} from '@malt/utils';

export const useImmersionStore = defineStore('immersion', () => {
    const identityId = ref('');
    const userInImmersion = ref<LightUser>();

    const hasRoleToAllowActionsInImmersion = ref<true | null>(null);

    async function saveImmersionData(newIdentityId: string, newUser: LightUser) {
        identityId.value = newIdentityId;
        userInImmersion.value = newUser;

        const hasRightPrivilege = await useHasEnoughPriviledge(['ROLE_ADMIN', 'ROLE_COMPLIANCE_DOCS']);
        // To not render the attribute, we have to send "null"
        const showButtonWithImmersion = hasRightPrivilege ? true : null;
        hasRoleToAllowActionsInImmersion.value = showButtonWithImmersion;
    }

    return {
        identityId: readonlyState(identityId),
        userInImmersion: readonlyState(userInImmersion),
        hasRoleToAllowActionsInImmersion: readonlyState(hasRoleToAllowActionsInImmersion),

        saveImmersionData,
    };
});
